module.exports = __webpack_public_path__ + "img/dogg2.6dcf4b92.png";